import React from "react";
import { useLocation } from "react-router-dom";
import { breadcrumbNameMap } from "./Constants";
import ContactLink from "./fragments/ContactLink";
import Button from "@mui/material/Button";

/**
 * Selects context-specific CTA content (callNowBlockTextFragment) based on the current route.
 * Matches:
 *  - exact keys in breadcrumbNameMap
 *  - dynamic patterns like /listing/:articleId
 * If no match found, shows the default static CTA (no parent-path fallback).
 */
function resolveRouteKey(pathname) {
  if (pathname.startsWith("/vehicleOrder/catalog/brand/")) return "/vehicleOrder/catalog";
  if (pathname.startsWith("/catalog-moto/brand/")) return "/catalog-moto";
  if (pathname.startsWith("/listing/brand/")) return "/listing";

  // Exact match
  if (breadcrumbNameMap[pathname]) return pathname;

  // Dynamic patterns declared as '/path/:param'
  const candidates = Object.keys(breadcrumbNameMap).sort((a, b) => b.length - a.length);
  for (const key of candidates) {
    const pattern = key
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      .replace(/:[a-zA-Z0-9_]+/g, "[^/]+");
    const re = new RegExp("^" + pattern + "$");
    if (re.test(pathname)) return key;
  }

  // No fallback to parent paths — return null to use default CTA.
  return null;
}

export default function CallNowBlock() {
  const { pathname } = useLocation();
  const routeKey = resolveRouteKey(pathname);
  const entry = routeKey ? (breadcrumbNameMap[routeKey] || {}) : {};
  const content = entry.callNowBlockTextFragment;

  return (
    <div className="site-section py-5" style={{ backgroundColor: "#364d59" }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-9 mb-4 mb-md-0">
            {content ? (
              content
            ) : (
              <>
                <h2 className="mb-0 text-white">Свяжитесь с нами </h2>
                <p className="mb-0 opa-7">
                  Наши специалисты ответят на все Ваши вопросы и помогут с выбором подходящего решения для Вас.
                </p>
              </>
            )}
          </div>
          <div className="col-lg-3 text-md-right">
            <ContactLink>
              <Button variant="contained" color="primary" component="span" aria-label="Связаться с нами">
                Связаться с нами
              </Button>
            </ContactLink>
          </div>
        </div>
      </div>
    </div>
  );
}
